import { render, staticRenderFns } from "./ClasificacionDocumentosPorMenosNumeroDescargas.vue?vue&type=template&id=23392e85&"
import script from "./ClasificacionDocumentosPorMenosNumeroDescargas.vue?vue&type=script&lang=js&"
export * from "./ClasificacionDocumentosPorMenosNumeroDescargas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports